import { render, staticRenderFns } from "./upFile.vue?vue&type=template&id=784d46d3&scoped=true"
import script from "./upFile.vue?vue&type=script&lang=js"
export * from "./upFile.vue?vue&type=script&lang=js"
import style0 from "./upFile.vue?vue&type=style&index=0&id=784d46d3&prod&scoped=true&lang=css"
import style1 from "./upFile.vue?vue&type=style&index=1&id=784d46d3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784d46d3",
  null
  
)

export default component.exports